import PropTypes from 'prop-types';

import { LocaleProvider } from '@spotahome/ui-library';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

const getLocaleForPath = locale => (locale === 'en' ? '' : `/${locale}`);
const removeDuplicatedLocale = (destinationPath, locale) =>
  destinationPath.replace(`${locale}/${locale}/`, `${locale}/`);

const updateURL = (locale, routes) => {
  const destination = routes[locale];

  // Keep this logic so SEO pages (no locale in route) and location pages (locale in route) language switching works
  const destinationPath = removeDuplicatedLocale(
    `${getLocaleForPath(locale)}${destination}`,
    locale
  );

  window.location = destinationPath;
};

const getAvailableLocales = (locales, routing = {}) =>
  Object.keys(locales).filter(locale => routing[locale]);

export const SeoLocalesContainer = ({ children, routing }) => {
  const locales = useSoyuzLocales();
  const handleChange = selectedLocale => {
    updateURL(selectedLocale, routing);
  };

  return (
    <LocaleProvider
      availableLocales={getAvailableLocales(locales.ui, routing)}
      onLocaleChange={handleChange}
    >
      {children}
    </LocaleProvider>
  );
};

SeoLocalesContainer.propTypes = {
  routing: PropTypes.shape({
    [PropTypes.string]: PropTypes.string
  }).isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

export default SeoLocalesContainer;
